import React, { useState } from "react";
import {
  CheckCircleFill,
  XCircleFill,
  InfoCircle,
} from "react-bootstrap-icons";

const pricingPlans = [
  {
    months: 12,
    price: 3599,
    oldPrice: 12000,
    perMonth: 300,
    discount: "67% off",
    badge: "BEST VALUE",
  },
  {
    months: 6,
    price: 2599,
    oldPrice: 6000,
    perMonth: 433,
    discount: "57% off",
  },
  {
    months: 3,
    price: 1599,
    oldPrice: 3000,
    perMonth: 533,
    discount: "47% off",
  },
];

const comparisonData = {
  features: [
    { name: "Daily Yoga with Prashant Bais", values: [true, true, true] },
    { name: "Flexible Batch Timings", values: [true, true, true] },
    { name: "Daily Tasks for Better Lifestyle", values: [true, true, true] },
    { name: "Exclusive Whatsapp Group", values: [true, true, true] },
    { name: "Class Recordings", info: true, values: [true, true, false] },
    {
      name: "Monthly Sunday Masterclass",
      info: true,
      values: [true, false, false],
    },
    { name: "12 Sessions of Face Yoga", values: [true, false, false] },
  ],
  plans: [
    { months: "12 Months", badge: "BEST VALUE" },
    { months: "6 Months" },
    { months: "3 Months" },
  ],
};

export default function PricingComparision() {
  const [selectedPlan, setSelectedPlan] = useState(12);
  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">
        Pricing for <span className="text-warning">Daily Yoga Classes</span>
      </h2>

      <div className="bg-light p-4 rounded mb-5">
        <p className="mb-2">
          <strong>Choose your plan type</strong>
        </p>
        <div className="d-flex flex-wrap gap-3">
          {pricingPlans.map((plan) => (
            <div
              key={plan.months}
              className={`card flex-fill p-3 ${
                selectedPlan === plan.months ? "border-warning" : ""
              }`}
              style={{ minWidth: "200px", cursor: "pointer" }}
              onClick={() => setSelectedPlan(plan.months)}
            >
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <input
                    type="radio"
                    name="plan"
                    checked={selectedPlan === plan.months}
                    readOnly
                    className="me-2"
                  />
                  <strong>{plan.months} Months</strong>
                </div>
                {plan.badge && (
                  <span className="badge bg-warning text-dark">
                    {plan.badge}
                  </span>
                )}
              </div>

              <h4 className="mb-1">₹ {plan.price}</h4>
              <small className="text-muted text-decoration-line-through">
                ₹ {plan.oldPrice}
              </small>
              <span className="badge bg-success ms-2">{plan.discount}</span>

              <div className="mt-2">
                <small>₹ {plan.perMonth}/month</small>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Optional Plan Comparison Table */}
      <div className="mt-5">
        <h4 className="mb-4">Plan Comparison</h4>
        <div className="table-responsive">
          <table className="table align-middle text-center">
            <thead>
              <tr>
                <th className="text-start">Features</th>
                {comparisonData.plans.map((plan, i) => (
                  <th
                    key={i}
                    className={`fw-bold ${
                      plan.badge ? "border border-warning rounded bg-light" : ""
                    }`}
                    style={{
                      backgroundColor: plan.badge ? "#fff8f0" : "transparent",
                      borderWidth: plan.badge ? "1.5px" : "0",
                    }}
                  >
                    {plan.months}
                    {plan.badge && (
                      <div>
                        <span className="badge bg-warning text-dark mt-1">
                          {plan.badge}
                        </span>
                      </div>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparisonData.features.map((feature, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="text-start fw-semibold">
                    {feature.name}{" "}
                    {feature.info && (
                      <InfoCircle size={16} className="text-muted ms-1" />
                    )}
                  </td>
                  {feature.values.map((value, colIndex) => (
                    <td key={colIndex}>
                      {value ? (
                        <div
                          className="rounded-circle d-inline-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#ffe4b5",
                            width: "30px",
                            height: "30px",
                          }}
                        >
                          <CheckCircleFill size={18} color="#b57900" />
                        </div>
                      ) : (
                        <div
                          className="rounded-circle d-inline-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#ffe6e6",
                            width: "30px",
                            height: "30px",
                          }}
                        >
                          <XCircleFill size={18} color="#cc0000" />
                        </div>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
